
























import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class BhFlowItem extends Vue {
    @Prop({ default: '' })
    label!: string;

    @Prop({ default: false })
    isFirst!: boolean;

    @Prop({ default: false })
    nested!: boolean;

    @Prop({ default: '#fff' })
    nestedColor!: boolean;

    @Prop({ default() { return {}; } })
    data!: object;

    @Prop({ default() { return []; } })
    location!: object;

    @Prop({ default() { return []; } })
    value!: object;

    @Prop({ default: null })
    indexFrom!: number;

    @Prop({ default: () => null })
    eventHandler!: Function;

    @Prop({ default: false })
    native!: boolean;

    @Prop({ default: false })
    singleNested!: boolean;
    
}
